import Box from "@mui/material/Box";
import { STATUS_COLOR, STATUS_LABEL } from "../Report/ReportList/data";

interface StatusChipProps {
  status: string;
}

const NEUTRAL_COLOR = "#9e9e9e";

/**
 * Reusable status pill (dot + label) backed by the single source of truth
 * in `Report/ReportList/data.ts`. Mirrors the markup used in the report
 * list / submission tables. Unknown statuses fall back to a neutral gray
 * chip showing the raw value.
 */
export default function StatusChip({ status }: StatusChipProps) {
  const colorMap = STATUS_COLOR as Record<string, string>;
  const labelMap = STATUS_LABEL as Record<string, string>;

  const color = colorMap[status] ?? NEUTRAL_COLOR;
  const label = labelMap[status] ?? status;

  return (
    <Box
      sx={{
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        bgcolor: color + "1A",
        color,
        borderRadius: 4,
        px: 2,
        py: 0.5,
        fontWeight: 600,
        whiteSpace: "nowrap",
      }}
    >
      <Box
        sx={{
          width: 10,
          height: 10,
          flexShrink: 0,
          bgcolor: color,
          borderRadius: "50%",
          mr: 1,
        }}
      />
      {label}
    </Box>
  );
}
